module.exports = __webpack_public_path__ + "static/media/loadLorry.632e1f94.jpg";